import { useQuery } from 'react-query';
import { HALF_HOUR } from 'src/constant/time';
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { useNotification } from 'src/providers/notificationsProvider';
import { fetchDynamicLinks } from 'src/services/napi/dynamicLinks/fetchDynamicLinks';
import { Project } from 'src/services/napi/projects/interfaces/fetchProjects.interface';
import { DynamicLink } from 'src/services/napi/dynamicLinks/interfaces/dynamicLink.interface';
import { UseGetDynamicLinksQueryParams } from './interfaces/useGetDynamicLinksQuery.interface';

const getDynamicLinksQueryFn = async (
  onlyCreatedFromAdmin: boolean
): Promise<DynamicLink[] | undefined> => {
  const currentProject = getDataFromLocalStorage<Project>(LocalStorageKey.CURRENT_PROJECT);
  const { _id: projectId } = currentProject ?? {};

  if (!projectId) return;

  const response = await fetchDynamicLinks({ onlyCreatedFromAdmin, projectId });
  return response?.dynamicLinks;
};

export const useGetDynamicLinksQuery = (params: UseGetDynamicLinksQueryParams) => {
  const { notify } = useNotification();

  return useQuery({
    onError: () => {
      notify({ message: 'Error Loading data... Try again later', severity: 'error' });
      params.onError?.();
    },
    onSuccess: () => {
      params.onSuccess?.();
    },
    queryFn: () => getDynamicLinksQueryFn(params.onlyCreatedFromAdmin),
    queryKey: [QueryKey.DYNAMIC_LINKS, params.onlyCreatedFromAdmin],
    staleTime: HALF_HOUR
  });
};
